import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';
import { MEDIA_POST_KEYS } from '@linc-technologies/linced-common/utils/post-media';

export default class Media extends RESTSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      createTime: 0,
      updateTime: 0,
      sharedWith: 0,
      mediaType: 0,
      mediaSource: 0,
      fileSize: 0,
      canReplace: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;

    return super.normalize(model, hash, prop);
  }

  // The backend reads the post id only from postId. Media of a notice links
  // its post through the relationship of that notice type.
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    for (const key of MEDIA_POST_KEYS.values()) {
      json.postId ||= json[key];
      delete json[key];
    }
    return json;
  }
}
